import { StripeTerminal } from '@stripe/terminal-js';
import pRetry from 'p-retry';
import { PaymentsTerminalError } from '../payment-terminal-error';
import { isStripeErrorResponse } from './sdk-utils';

let stripeTerminalPromise: Promise<StripeTerminal | null> | null = null;

export const getStripeTerminalSDK = async () => {
  try {
    if (!stripeTerminalPromise) {
      const { loadStripeTerminal } = await import('@stripe/terminal-js');
      stripeTerminalPromise = pRetry(() => loadStripeTerminal(), { retries: 3 });
    }
    const result = await stripeTerminalPromise;
    if (!result) {
      throw new Error();
    }
    return result;
  } catch (error) {
    if (isStripeErrorResponse(error)) {
      throw new PaymentsTerminalError('initialize', error.error);
    }
    throw new PaymentsTerminalError(
      'initialize',
      'Stripe Terminal SDK is not loaded, check that stripe domains are whitelisted'
    );
  }
};
